// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-group-link-message[data-v-4618789c] {
  display: flex;
  flex-direction: column;
  cursor: pointer;
}
.chat-group-link-message .message-body[data-v-4618789c] {
  display: flex;
  flex-direction: column;
  background-color: var(--bg-color-rgb1);
  margin-bottom: 8px;
  border-left: 3px solid var(--item-color-8);
  border-radius: .4rem;
  margin-top: 0.34em;
  color: var(--group-link-message-color);
}
.chat-group-link-message .message-body[data-v-4618789c]:hover {
  background-color: var(--bg-color-rgb2);
}
.chat-group-link-message .message-body .group-info[data-v-4618789c] {
  display: flex;
  align-items: center;
  padding: 4px;
}
.chat-group-link-message .message-body .group-info .group-info-right[data-v-4618789c] {
  display: flex;
  flex-direction: column;
}
.chat-group-link-message .message-body .group-info .group-info-right .group-invitation[data-v-4618789c],
.chat-group-link-message .message-body .group-info .group-info-right .group-basic-info[data-v-4618789c] {
  display: flex;
  padding-bottom: 0.15rem;
  padding-left: 0.5rem;
  font-size: 1em;
}
.chat-group-link-message .message-body .group-info .group-info-right .group-basic-info[data-v-4618789c] {
  flex-direction: column;
}
.chat-group-link-message .message-body .group-join[data-v-4618789c] {
  display: flex;
  height: 3.8rem;
  justify-content: center;
  align-items: center;
  border-top: 1px solid var(--group-join-line-color);
  width: 100%;
}
.chat-group-link-message .message-body .group-join .join-text[data-v-4618789c] {
  align-self: center;
  text-transform: uppercase ;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/chat/ChatGroupLinkMessage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,kBAAkB;EAClB,0CAA0C;EAC1C,oBAAoB;EACpB,kBAAkB;EAClB,sCAAsC;AACxC;AACA;EACE,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;;EAEE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;EAClD,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B","sourcesContent":[".chat-group-link-message[data-v-4618789c] {\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n}\n.chat-group-link-message .message-body[data-v-4618789c] {\n  display: flex;\n  flex-direction: column;\n  background-color: var(--bg-color-rgb1);\n  margin-bottom: 8px;\n  border-left: 3px solid var(--item-color-8);\n  border-radius: .4rem;\n  margin-top: 0.34em;\n  color: var(--group-link-message-color);\n}\n.chat-group-link-message .message-body[data-v-4618789c]:hover {\n  background-color: var(--bg-color-rgb2);\n}\n.chat-group-link-message .message-body .group-info[data-v-4618789c] {\n  display: flex;\n  align-items: center;\n  padding: 4px;\n}\n.chat-group-link-message .message-body .group-info .group-info-right[data-v-4618789c] {\n  display: flex;\n  flex-direction: column;\n}\n.chat-group-link-message .message-body .group-info .group-info-right .group-invitation[data-v-4618789c],\n.chat-group-link-message .message-body .group-info .group-info-right .group-basic-info[data-v-4618789c] {\n  display: flex;\n  padding-bottom: 0.15rem;\n  padding-left: 0.5rem;\n  font-size: 1em;\n}\n.chat-group-link-message .message-body .group-info .group-info-right .group-basic-info[data-v-4618789c] {\n  flex-direction: column;\n}\n.chat-group-link-message .message-body .group-join[data-v-4618789c] {\n  display: flex;\n  height: 3.8rem;\n  justify-content: center;\n  align-items: center;\n  border-top: 1px solid var(--group-join-line-color);\n  width: 100%;\n}\n.chat-group-link-message .message-body .group-join .join-text[data-v-4618789c] {\n  align-self: center;\n  text-transform: uppercase ;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
